(function () {
  const root = document.querySelector('.pat-patoun-collection');
  if (!root) return;

  const fold = root.querySelector('.intro-fold');
  if (fold) {
    const intro = fold.querySelector('.intro');
    const more = fold.querySelector('.intro-more');
    const setLabel = (open) => {
      more.textContent = open ? 'Lire moins' : 'Lire plus';
      more.setAttribute('aria-expanded', String(open));
    };
    const fit = () => {
      const wasOpen = fold.classList.contains('is-open');
      fold.classList.add('can-fold');
      fold.classList.remove('is-open');
      intro.style.setProperty('-webkit-line-clamp', 'unset');
      intro.style.display = 'block';
      const full = intro.scrollHeight;
      intro.style.removeProperty('-webkit-line-clamp');
      intro.style.removeProperty('display');
      const overflows = full > intro.clientHeight + 2;
      more.hidden = !overflows;
      if (wasOpen && overflows) fold.classList.add('is-open');
      setLabel(fold.classList.contains('is-open'));
    };
    more.addEventListener('click', () => {
      const open = fold.classList.toggle('is-open');
      setLabel(open);
    });
    fit();
    window.addEventListener('resize', fit);
  }

  const phonePromo = window.matchMedia('(max-width: 759px)');
  root.querySelectorAll('.promo-fold').forEach((fold) => {
    const note = fold.querySelector('p');
    const more = fold.querySelector('.promo-more');
    if (!note || !more) return;
    const setLabel = (open) => {
      more.textContent = open ? 'Lire moins' : 'Lire plus';
      more.setAttribute('aria-expanded', String(open));
    };
    const fit = () => {
      if (!phonePromo.matches) {
        fold.classList.remove('can-fold', 'is-open');
        more.hidden = true;
        return;
      }
      const wasOpen = fold.classList.contains('is-open');
      fold.classList.add('can-fold');
      fold.classList.remove('is-open');
      note.style.setProperty('-webkit-line-clamp', 'unset');
      note.style.display = 'block';
      const full = note.scrollHeight;
      note.style.removeProperty('-webkit-line-clamp');
      note.style.removeProperty('display');
      const overflows = full > note.clientHeight + 2;
      more.hidden = !overflows;
      if (wasOpen && overflows) fold.classList.add('is-open');
      setLabel(fold.classList.contains('is-open'));
    };
    more.addEventListener('click', () => {
      const open = fold.classList.toggle('is-open');
      setLabel(open);
    });
    phonePromo.addEventListener('change', fit);
    fit();
  });

  const guide = root.querySelector('.col-guide .ds');
  if (guide) {
    const items = [...guide.querySelectorAll('.ds-item')];
    const mq = window.matchMedia('(max-width: 900px)');
    const setOn = (it, v) => {
      it.classList.toggle('is-on', v);
      const h = it.querySelector('.ds-h');
      if (h) h.setAttribute('aria-expanded', String(v));
    };
    const act = (it) => {
      const was = it.classList.contains('is-on');
      items.forEach((o) => { if (o !== it) setOn(o, false); });
      setOn(it, mq.matches ? !was : true);
    };
    items.forEach((it) => {
      const h = it.querySelector('.ds-h');
      h.addEventListener('click', () => act(it));
      h.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); act(it); }
      });
    });
    mq.addEventListener('change', () => {
      if (!mq.matches && !items.some((i) => i.classList.contains('is-on'))) setOn(items[0], true);
    });
  }

  const grid = root.querySelector('#patGrid');
  if (!grid) return;

  const cards = [...grid.querySelectorAll('.card')];
  const promo = grid.querySelector('.promo');
  const empty = root.querySelector('#patEmpty');
  const resetBtn = root.querySelector('#patReset');
  const cnt = root.querySelector('#patCnt');
  const sort = root.querySelector('#patSort');
  const chips = [...root.querySelectorAll('.chip')];
  const act = { pos: new Set(), mat: new Set() };
  const total = cards.length;
  const noun = root.dataset.noun || 'produits';
  const nounOne = root.dataset.nounOne || 'produit';

  function label(n) {
    return n + ' ' + (n > 1 ? noun : nounOne);
  }

  function apply() {
    let n = 0;
    const any = Object.values(act).some((s) => s.size);
    cards.forEach((c) => {
      const ok = ['pos', 'mat'].every((f) => !act[f].size || act[f].has(c.dataset[f]));
      c.hidden = !ok;
      if (ok) n += 1;
    });
    if (promo) promo.hidden = any || (sort && sort.value !== 'rec');
    if (empty) empty.hidden = n > 0;
    if (resetBtn) resetBtn.hidden = !any;
    if (cnt) cnt.textContent = label(n);

    const v = sort ? sort.value : 'rec';
    const list = [...cards].sort((a, b) => {
      if (v === 'asc') return Number(a.dataset.p) - Number(b.dataset.p);
      if (v === 'desc') return Number(b.dataset.p) - Number(a.dataset.p);
      return Number(a.dataset.i) - Number(b.dataset.i);
    });
    list.forEach((c) => grid.insertBefore(c, empty || null));
    if (promo && v === 'rec' && !any) {
      const shown = list.filter((c) => !c.hidden);
      let at = 8;
      if (window.matchMedia('(max-width: 759px)').matches) {
        at = Math.floor(shown.length / 2);
        if (at % 2) at += 1;
      }
      const anchor = shown[at] || empty;
      grid.insertBefore(promo, anchor || null);
    }

    const seen = root.querySelector('#patSeen');
    const prog = root.querySelector('#patProg');
    if (seen) seen.textContent = 'Vous avez vu ' + n + ' ' + (n > 1 ? noun : nounOne) + ' sur ' + total;
    if (prog) prog.style.width = (total ? Math.round((n / total) * 100) : 0) + '%';
  }

  chips.forEach((ch) => {
    ch.addEventListener('click', () => {
      const on = ch.getAttribute('aria-pressed') !== 'true';
      ch.setAttribute('aria-pressed', String(on));
      const set = act[ch.dataset.f];
      if (!set) return;
      if (on) set.add(ch.dataset.v);
      else set.delete(ch.dataset.v);
      apply();
    });
  });

  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      chips.forEach((c) => c.setAttribute('aria-pressed', 'false'));
      Object.values(act).forEach((s) => s.clear());
      apply();
    });
  }

  root.querySelectorAll('[data-pat-clear]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (resetBtn) resetBtn.click();
    });
  });

  if (sort) sort.addEventListener('change', apply);
  window.matchMedia('(max-width: 759px)').addEventListener('change', apply);

  apply();
})();
